import api from "../axios";

export const listRoles = (params) => api.get("roles/", { params }); // ?search=OWNER
export const createRole = (data) => api.post("roles/", data);
export const updateRole = (id, data) => api.put(`roles/${id}/`, data);
export const patchRole = (id, data) => api.patch(`roles/${id}/`, data);
export const deleteRole = (id) => api.delete(`roles/${id}/`);
